import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import combineStyles from '../../../../helpers/combineStyles';
import ButtonStyles from '../../../../styles/button';
import TypographyStyles from '../../../../styles/typography';
import BulkLoad from '../../../shared/BulkLoad/BulkLoad';
import CustomDialog from '../../../shared/Modals/CustomDialog';

class SinisterMassive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: ''
    };
  }

  _handleSave = async () => {
    const response = await this.props.handleSave(this.state.file);

    this.file = '';

    if (response.success) {
      this._handleClose();
    }
  };

  _handleClose = () => {
    const { requestSend } = this.props;
    if (!requestSend) this.props.onClose();
  };

  handleChangeFile = file => this.setState({ file });

  _disableSubmit = () => !this.state.file;

  render() {
    const {
      classes,
      requestSend,
      canCreateRevokeMassiveSinisterSales
    } = this.props;

    return (
      <div>
        <CustomDialog
          open={true}
          loading={requestSend}
          disabled={this._disableSubmit() || requestSend}
          disableBackdropClick={true}
          headerSecondary={<div />}
          onClose={this._handleClose}
          onConfirm={() => this._handleSave(false)}
          title={'Rechazo masivos de siniestros'}
          buttonText={'Guardar'}
          classes={{
            root: classes.dialogRoot
          }}
        >
          {canCreateRevokeMassiveSinisterSales && (
            <BulkLoad
              templatePath={'/docs/plantilla-siniestro-masivo.xlsx'}
              handleChangeFile={this.handleChangeFile}
            />
          )}
        </CustomDialog>
      </div>
    );
  }
}

const styles = () => ({
  dialogRoot: {
    width: 800
  }
});

SinisterMassive.propTypes = {
  classes: PropTypes.object.isRequired,
  requestSend: PropTypes.bool,
  canCreateRevokeMassiveSinisterSales: PropTypes.bool,
  handleSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default withStyles(
  combineStyles(styles, TypographyStyles, ButtonStyles),
  {
    withTheme: true
  }
)(SinisterMassive);
